module.exports = __webpack_public_path__ + "img/tooth3.1893d7bf.png";